import * as React from "react";
import { cn } from "../lib/utils.js";

type StatusDotVariant = "active" | "inactive" | "warning" | "error";

interface StatusDotProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: StatusDotVariant;
}

const variantClasses: Record<StatusDotVariant, string> = {
  active: "bg-accent-teal shadow-[0_0_8px_var(--accent-teal)]",
  inactive: "bg-muted-foreground/40",
  warning: "bg-accent-gold shadow-[0_0_8px_var(--accent-gold)]",
  error: "bg-destructive",
};

function StatusDot({
  variant = "inactive",
  className,
  ...props
}: StatusDotProps) {
  return (
    <span
      className={cn(
        "inline-block h-2 w-2 rounded-full shrink-0",
        variantClasses[variant],
        className,
      )}
      aria-hidden="true"
      {...props}
    />
  );
}

export { StatusDot };
export type { StatusDotVariant };
